import React, { useState, useEffect } from "react";
import Breadcrumb from "../components/Breadcrumb";
import axios from "axios";

function TravelInsurance() {
  const [content, setContent] = useState({ text: "" });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await axios.get(
          "/api/information/public/insuranceConditions"
        );
        setContent(response.data);
      } catch (error) {
        console.error("Error fetching insurance conditions content:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchContent();
  }, []);

  if (loading) {
    return (
      <div className="bg-white min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-600 mx-auto"></div>
          <p className="mt-4 text-gray-700">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white min-h-screen pt-[60px]">
      <main
        className="max-w-[1280px] mx-auto py-12 px-6 md:px-12"
        aria-label="Travel Insurance"
      >
        <div className="-ml-3 -mt-6 sm:mt-8 sm:ml-0">
          <Breadcrumb
            items={[
              { label: "Home", href: "/" },
              {
                label: "Travel Cancellation Insurance",
                href: "/travel-cancellation-insurance",
              },
            ]}
          />
        </div>

        <h1 className="text-4xl md:text-3xl text-left mb-4 mt-12">
          Travel Cancellation Insurance
        </h1>
        <div className="text-gray-700 text-lg leading-relaxed whitespace-pre-wrap text-left" dangerouslySetInnerHTML={{
          __html: content.text ||
            "No travel insurance information available at this time."
        }} />
      </main>
    </div>
  );
}

export default TravelInsurance;
